module.exports = __webpack_public_path__ + "static/price-tag-generator-desktop-2.f83cf1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/price-tag-generator/img/price-tag-generator-desktop-2.png
// module id = 618
// module chunks = 166649263963851